import { useTranslation } from 'react-i18next';
import {
  CookiePolicyWrapper,
  TitlePage,
  CookieRuleText,
  TitleSection,
} from './styled';

export const CookiePolicy = () => {
  const { t } = useTranslation();
    
  return (
    <CookiePolicyWrapper>
      <TitlePage>{t('cookiePolicy')}</TitlePage>
      <CookieRuleText>{t('titleCookies')}</CookieRuleText>
      <CookieRuleText>{t('whatThisIs')}</CookieRuleText>
      <TitleSection>{t('whatAreCookies')}</TitleSection>
      <CookieRuleText>{t('websitesUseCookie')}</CookieRuleText>
      <TitleSection>{t('howWeUseCookies')}</TitleSection>
      <CookieRuleText>{t('weUseCookiesFor')}</CookieRuleText>
      <TitleSection>{t('disablingCookies')}</TitleSection>
      <CookieRuleText>{t('youCanPreventUsingCookies')}</CookieRuleText>
      <CookieRuleText>{t('cookiesWeSet')}</CookieRuleText>
      <TitleSection>{t('accountRelatedCookie')}</TitleSection>
      <CookieRuleText>{t('afterCreatingAccount')}</CookieRuleText>
      <TitleSection>{t('loginRelatedCookies')}</TitleSection>
      <CookieRuleText>{t('weUseCookiesWhenYouLogged')}</CookieRuleText>
      <TitleSection>{t('sitePreferencesCookies')}</TitleSection>
      <CookieRuleText>{t('whyPreferencesCookies')}</CookieRuleText>
      <TitleSection>{t('thirdPartyCookies')}</TitleSection>
      <CookieRuleText>{t('inSomeSpecialCases')}</CookieRuleText>
      <CookieRuleText>{t('siteUsesGoogleAnalytics')}</CookieRuleText>
      <CookieRuleText>{t('seeItInGoogle')}</CookieRuleText>
      <CookieRuleText>{t('trackUseOfWebsite')}</CookieRuleText>
      <CookieRuleText>{t('testNewFeatures')}</CookieRuleText>
      <CookieRuleText>{t('understandStatistics')}</CookieRuleText>
      <CookieRuleText>{t('advertisingViaGoogleTechnology')}</CookieRuleText>
      <CookieRuleText>{t('googleAdSense')}</CookieRuleText>
      <CookieRuleText>{t('forMoreInfo')}</CookieRuleText>
      <CookieRuleText>{t('fundingForDevelopment')}</CookieRuleText>
      <TitleSection>{t('moreInformation')}</TitleSection>
      <CookieRuleText>{t('clarifiedThings')}</CookieRuleText>
      <CookieRuleText>{t('forMoreGeneralInfo')}</CookieRuleText>
      <CookieRuleText>{t('contactUs')}</CookieRuleText>
      <CookieRuleText>{t('emailItah')}</CookieRuleText>
    </CookiePolicyWrapper>
  );
};
